export const PAGINATION_EVENTS = {
  SELECT_CATALOG_PAGE: "web_select_catalog_page",
};
